import { createAction } from 'redux-actions';

export const setErrorMessage = createAction<string>('SET_ERROR_MESSAGE');
export const clearErrorMessage = createAction('CLEAR_ERROR_MESSAGE');
